"use client";

import { Faq } from "@/providers/strapi/content/types/components/shared.component";
import * as X from "@/ui";
import ReactMarkdown from "react-markdown";


// const data = {
//   questions: [
//     {
//       title: {
//         en: "What is a VAT refund?",
//         fr: `C'est quoi la détaxe${X.Nbsp}?`,
//       },
//       answer: {
//         en: (
//           <>
//             <p>VAT refund (or tax-free shopping) is a scheme that allows travelers residing outside the European Union (EU) to reclaim the Value Added Tax (VAT) paid on purchases made during their stay in the EU. This mechanism aims to encourage tourism by offering international visitors the opportunity to save money on their shopping.</p>
//             <p>Eligible travelers can request a refund on goods they take back home with them. To do so, they must have their tax-free form validated by Customs when leaving the EU.</p>
//             <p>Note that VAT refunds apply only to exported goods carried in your personal luggage, and not to services or items consumed on-site. Each EU country may also set specific conditions, such as minimum spending thresholds, to qualify for a refund.</p>
//             <p>In short, the VAT refund system gives international travelers a way to save on purchases made in the EU—making their shopping experience even more rewarding.</p>
//           </>
//         ),
//         fr: (
//           <>
//             <p>La détaxe est un dispositif fiscal permettant aux voyageurs résidant en dehors de l'Union européenne (UE) de récupérer la taxe sur la valeur ajoutée (TVA) payée sur des achats effectués lors de leur séjour dans l'UE. Ce mécanisme vise à encourager le tourisme en offrant aux visiteurs internationaux la possibilité de réaliser des économies sur leurs dépenses.</p>
//             <p>En pratique, les voyageurs éligibles peuvent demander un remboursement de la TVA sur les biens qu'ils emportent avec eux à leur retour dans leur pays de résidence. Cette procédure nécessite généralement la validation des documents de détaxe par les autorités douanières lors de la sortie du territoire de l'UE.</p>
//             <p>Il est important de noter que la détaxe s'applique uniquement aux biens exportés dans les bagages personnels du voyageur et non aux services ou consommations sur place. De plus, chaque pays de l'UE peut fixer des conditions spécifiques, telles que des montants d'achat minimums, pour bénéficier de ce remboursement.</p>
//             <p>En résumé, la détaxe offre aux voyageurs internationaux une opportunité de récupérer la TVA sur leurs achats effectués dans l'UE, contribuant ainsi à rendre leur expérience de shopping plus avantageuse.</p>
//           </>
//         ),
//       },
//     },
//     // {
//     //   title: {
//     //     en: "Who is eligible for a VAT refund with Zapptax?",
//     //     fr: `Qui peut bénéficier de la détaxe avec Zapptax${X.Nbsp}?`,
//     //   },
//     //   answer: {
//     //     en: (
//     //       <>
//     //         <p>You can benefit from the VAT refund if you meet all three of the following conditions: </p>
//     //         <ul>
//     //           <li>You reside outside the European Union (EU)</li>
//     //           <li>You are at least 16 years old</li>
//     //           <li>Your stay in the EU is shorter than six months</li>
//     //         </ul>
//     //         <p>What documents do I need to provide?</p>
//     //         <ul>
//     //           <li><strong>If you hold a passport from a non-EU country</strong>: Simply upload a copy of your passport.</li>
//     //           <li><strong>If you hold a passport from an EU country</strong>: You’ll need to provide an additional document proving your residence outside the EU (e.g. consular ID, expatriate certificate, UK settled/pre-settled status, green card, etc.).</li>
//     //         </ul>
//     //       </>
//     //     ),
//     //     fr: (
//     //       <>
//     //         <p>Vous pouvez profiter de la détaxe si vous remplissez ces trois conditions :</p>

//     //         <ul>
//     //           <li>Vous résidez hors de l’Union européenne (UE)</li>
//     //           <li>Vous avez au moins 16 ans</li>
//     //           <li>Votre séjour dans l’UE dure moins de six mois</li>
//     //         </ul>

//     //         <p>Quels documents fournir ?</p>

//     //         <ul>
//     //           <li><strong>Si vous avez un passeport d'un pays non-membre de l'UE</strong>: Il suffit d’en télécharger une copie.</li>
//     //           <li><strong>Si vous avez un passeport d'un pays membre de l'UE</strong>: Ajoutez un document prouvant votre résidence hors de l’UE (ex. carte consulaire, attestation d’expatrié, settled/pre-settled status au Royaume-Uni, green card, etc.).</li>
//     //         </ul>
//     //       </>
//     //     ),
//     //   },
//     // },
//     // {
//     //   title: {
//     //     en: "What type of purchases are eligible for a VAT refund?",
//     //     fr: `Quels types d'achats sont éligibles à la détaxe${X.Nbsp}?`,
//     //   },
//     //   answer: {
//     //     en: (
//     //       <>
//     //         <p>All of them.</p>
//     //         <p>Almost all your purchases are eligible, as long as you’re taking the items with you in your personal luggage when leaving the EU. </p>
//     //         <p>Exceptions (non-eligible items):</p>
//     //         <ul>
//     //           <li>Manufactured tobacco (note: e-cigarettes and e-liquids are eligible).</li>
//     //           <li>Vehicles such as karts, quads, snowmobiles, and microlights (bicycles, e-bikes under 250 watts, trailers, and caravans are eligible).</li>
//     //           <li>Vehicle parts like tires, brakes, engine components</li>
//     //           <li>Firearms, explosives, protected species, illegal drugs or substances</li>
//     //           <li>Fuel and petroleum products.</li>
//     //           <li>Certain high-value cultural goods.</li>
//     //         </ul>
//     //         <p>Note sure about an item? Just reach out via our in-app chat!</p>
//     //         <p>Non-eligible categories:</p>
//     //         <ul>
//     //           <li>Services (e.g.hotels, restaurants, taxis...)</li>
//     //           <li>Commercial purchases or items intended for resale.</li>
//     //         </ul>
//     //       </>
//     //     ),
//     //     fr: (
//     //       <>
//     //         <p>Tous vos achats.</p>
//     //         <p>Tous vos achats sont éligible à la détaxe pour autant que vous emmeniez les articles dans vos bagages personnels, lorsque vous quittez l’UE.</p>
//     //         <p>Exceptions{X.Nbsp}:</p>
//     //         <ul>
//     //           <li>Tabacs manufacturés (les cigarettes électroniques et e-liquides sont éligibles).</li>
//     //           <li>Les moyens de transports tels que karts, quads, motoneiges, ULM (les vélos, vélos électriques {"< 250"} watts, remorques et caravanes sont éligibles).</li>
//     //           <li>Les pièces mécaniques des véhicules tels que pneus, freins, pièces moteurs…</li>
//     //           <li>Armes à feu, produits explosifs, espèces protégées, stupéfiants, psychotropes…</li>
//     //           <li>Les produits pétroliers.</li>
//     //           <li>Certains biens culturels de grande valeur.</li>
//     //         </ul>
//     //         <p>En cas de doute, contactez-nous via le chat.</p>
//     //         <p>Les services (hôtels, restaurant, taxis…) et les achats à caractère commercial ne sont pas éligibles à la détaxe.</p>
//     //       </>
//     //     ),
//     //   },
//     // },
//     // {
//     //   title: {
//     //     en: "Where can I use Zapptax?",
//     //     fr: `Où puis-je utiliser Zapptax${X.Nbsp}?`,
//     //   },
//     //   answer: {
//     //     en: (
//     //       <>
//     //         <p><strong>In which countries?</strong> Zapptax is currently available in:</p>
//     //         <ul>
//     //           <li>France</li>
//     //           <li>Belgium</li>
//     //           <li>Spain</li>
//     //         </ul>
//     //         <p>More countries will be added soon!</p>
//     //         <p><strong>In which stores?</strong> You can shop in any store, as long as you get an invoice issued in the name of Zapptax.</p>
//     //         <p><strong>In which stores?</strong> You can shop in any store, as long as you get an invoice issued in the name of Zapptax.</p>
//     //         <p><strong>What about online shopping?</strong> Yes, Zapptax works for online purchases too, as long as the invoice is also issued to Zapptax.</p>
//     //       </>
//     //     ),
//     //     fr: (
//     //       <>
//     //         <p>Dans quels pays ?</p>
//     //         <ul>
//     //           <li>en France,</li>
//     //           <li>en Belgique,</li>
//     //           <li>et en Espagne.</li>
//     //         </ul>
//     //         <p>D’autres pays se rajouteront à cette liste prochainement.</p>
//     //         <p><strong>Dans quelles enseignes{X.Nbsp}?</strong> Dans n’importe quel magasin, à condition d’obtenir une facture au nom de Zapptax.</p>
//     //         <p><strong>Et en ligne{X.Nbsp}?</strong> Oui ! Sous réserve également d’obtenir une facture au nom de Zapptax.</p>
//     //       </>
//     //     ),
//     //   },
//     // },
//     // {
//     //   title: {
//     //     en: "How long does it take to get my refund?",
//     //     fr: `En combien de temps vais-je recevoir mon remboursement${X.Nbsp}?`,
//     //   },
//     //   answer: {
//     //     en: (
//     //       <>
//     //         <p>We aim to process your VAT refund within 1 to 3 weeks, amongthe fastest turnaround times on the market.</p>
//     //         <p>Sometimes, external factors like administrative delays from tax authorities or peak travel seasons (summer, holidays…) can extend this timeframe by a few days or weeks.</p>
//     //         <p><strong>But here’s the good news</strong>: Once your tax-free form is validated by Customs, your refund is guaranteed. Since our launch in 2017, we’ve refunded every single validated form we’ve received — no exceptions.</p>
//     //       </>
//     //     ),
//     //     fr: (
//     //       <>
//     //         <p>Nous mettons tout en œuvre pour vous rembourser sous 1 à 3 semaines, l’un des délais les plus rapides du marché !</p>
//     //         <p>Il arrive cependant que des facteurs externes – comme des délais administratifs des autorités fiscales ou une forte affluence (été, fêtes de fin d’année) – allongent ce délai de quelques jours ou semaines.</p>
//     //         <p><strong>Ce qui est certain</strong>{X.Nbsp}: votre remboursement est garanti dès lors que votre bordereau de détaxe est validé. Depuis notre lancement en 2017, nous avons remboursé sans exception tous les bordereaux validés qui nous ont été présentés.</p>
//     //       </>
//     //     ),
//     //   },
//     // },
//   ] as Array<{
//     title: X.Localization<string>;
//     answer: X.Localization<React.ReactNode>;
//   }>,
// };

// const buildFaq = (faq: Faq): Array<{
//   title: string;
//   answer: React.ReactNode;
// }> => (
//   faq.questions.map((f) => ({
//     title: f.question,
//     answer: <ReactMarkdown>
//       {f.response}
//     </ReactMarkdown>
//   }))
//   //   [
//   //   {
//   //     title: tr('faqs.faq1.title'),
//   //     answer: tr('faqs.faq1.answer'),
//   //   },

//   // ]
// )


export function FeaturedFaqSection({ locale, faqSection }: X.PageProps<{ faqSection: Faq }>) {
  // const tr = X.useTranslator();
  // const faqSection = useTravelerHomePage('faq');
  // const data = buildFaq(faqSection);
  // const questions = X.useMemo(() => {
  //   return data.map(({ title, answer }) => {
  //     return {
  //       title: title,
  //       answer: answer,
  //     };
  //   });
  // }, [locale]);

  return (
    <section id="faq" className="my-12 xl:my-20 scroll-mt-[120px]">
      <div className="mx-mobile-margin xl:max-w-[808px] xl:mx-auto">
        <h2 className="text-[26px] xl:text-[48px] [&_strong]:font-medium center mb-6 text-center">
          <ReactMarkdown>
            {faqSection.title}
          </ReactMarkdown>
          {/* {tr({
            en: <><strong>Frequently</strong> Asked Questions</>,
            fr: <>Vos questions <strong>fréquentes</strong></>,
          })} */}
        </h2>
        <X.Questions
          locale={locale}
          questions={faqSection.questions}
        // questions={questions}
        />
        <div className="flex flex-col justify-center items-start xl:items-center mt-10">
          <X.Button
            secondary
            desktopLg
            href="/faq"
            label={faqSection.showMoreCta}
          // label={tr({
          //   en: "More Questions",
          //   fr: "Voir toutes les questions",
          // })}
          />
        </div>
      </div>
    </section>
  );
}
